var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "27",
      "height": "27",
      "viewBox": "0 0 27 27",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.80812 9.2373L18.4403 18.8695M8.80812 9.2373L18.4403 18.8695",
      "stroke": "#D9D9D9",
      "stroke-width": "1.95452",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.4402 9.2373L8.808 18.8695M18.4402 9.2373L8.808 18.8695",
      "stroke": "#D9D9D9",
      "stroke-width": "1.95452",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.3023 25.9327C20.0406 25.9327 25.503 20.4702 25.503 13.732C25.503 6.9937 20.0406 1.53125 13.3023 1.53125C6.56404 1.53125 1.10159 6.9937 1.10159 13.732C1.10159 20.4702 6.56404 25.9327 13.3023 25.9327Z",
      "stroke": "#D9D9D9",
      "stroke-width": "1.95452"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };